import React from "react";
import logo from "../Images/Logos/ND-common-transparent.png";
import { Link, useNavigate } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import Training from "../Images/FooterImages/training-img.jpg";
import { FaLocationDot } from "react-icons/fa6";
import { RxArrowRight } from "react-icons/rx";
import { FaYoutube } from "react-icons/fa";

import {
  AboutUsData,
  OurWorkData,
  UsefulLinks,
} from "../Components/Utils/data";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate("/");
  };

  return (
    <footer className="relative text-white text-xl">
      <div
        className="absolute inset-0 z-0 bg-cover overflow-hidden bg-center"
        style={{ backgroundImage: `url(${Training})` }}
      ></div>
      <div className="absolute inset-0 z-0  bg-ndlogoBlue opacity-80"></div>

      <div className="relative z-10 w-[95%] mx-auto px-4 py-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8">
        {/* ****************************** Logo and Description ****************************** */}
        <div className="col-span-1 md:col-span-4 lg:col-span-2">
          <img
            src={logo}
            alt="Business Logo"
            className="w-56 mb-4 cursor-pointer"
            onClick={handleNavigation}
          />
          <p className=" text-base leading-relaxed">
            Lorem ipsum dolor amet consectetur adipisicing dolor magna aliqua
            elit sed eiusmod tempor incididunt labore dolor magna aliqua enim ad
            minimveniam quis nostrud exercita.Lorem ipsum dolor amet consectetur
            adipisicing dolor magna.
          </p>
        </div>

        {/* ****************************** Useful Links *******************************/}
        <div>
          <h4 className="text-lg font-semibold mb-3    transition duration-300">
            Quick Links
          </h4>
          {UsefulLinks.map((item, i) => {
            return (
              <ul key={i} className="space-y-2 text-base">
                <li className=" flex flex-row justify-content-center items-center gap-2 mb-2">
                  <RxArrowRight />
                  <Link to={item.link} className="hover:text-Orange transition">
                    {item.title}
                  </Link>
                </li>
              </ul>
            );
          })}
        </div>

        {/* ****************************** About Us ****************************** */}
        <div>
          <h4 className="text-lg font-semibold mb-3">About Us</h4>
          {AboutUsData.map((item, i) => {
            return (
              <ul key={i} className="space-y-2 text-base">
                <li className=" flex flex-row justify-content-center items-center gap-2 mb-2">
                  <RxArrowRight />
                  <Link to={item.link} className="hover:text-Orange transition">
                    {item.title}
                  </Link>
                </li>
              </ul>
            );
          })}
        </div>

        {/* ****************************** Our Work ****************************** */}
        <div>
          <h4 className="text-lg font-semibold mb-3">Our Work</h4>
          {OurWorkData.map((item, i) => {
            return (
              <ul key={i} className="space-y-2 text-base">
                <li className=" flex flex-row justify-content-center items-center gap-2 mb-2">
                  <RxArrowRight />

                  <Link to={item.link} className="hover:text-Orange transition">
                    {item.title}
                  </Link>
                </li>
              </ul>
            );
          })}
        </div>

        {/* ****************************** Location ****************************** */}
        <div>
          <h4 className="text-lg font-semibold mb-3 ">Location</h4>

          <Link
            className="hover:text-Orange transition"
            to="https://www.google.co.in/maps/@17.4816458,78.5587343,3a,90y,211.13h,92.17t/data=!3m6!1e1!3m4!1sG_1f65Gy9td9HbmS1E-k3A!2e0!7i13312!8i6656?entry=ttu"
            target="_blank"
          >
            <p className=" text-base">
              Plot No.59, Brindavan Colony, A. S. Rao Nagar,ECIL, Hyderabad,
              Secunderabad, Telangana 500062
            </p>
          </Link>
        </div>
      </div>
      {/* Other Links */}
      {/* <div>
        <h4 className="text-base font-semibold mb-3">Other Links</h4>
        <ul className="space-y-2">
          <li className="hover:text-Orange transition cursor-pointer">
            Terms & Conditions
          </li>
        </ul>
      </div> */}

      {/* ****************************** Bottom Bar ****************************** */}
      <div className="relative z-10 border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-lightGray text-sm text-center">
            © 2025 newdirection.org.in — All Rights Reserved.
          </p>
          <div className="flex gap-4">
            <Link
              to="#"
              className="p-2 bg-white/10 rounded-full hover:bg-Orange transition"
            >
              <FaFacebookF />
            </Link>
            <Link
              to="#"
              className="p-2 bg-white/10 rounded-full hover:bg-Orange transition"
            >
              <FaInstagram />
            </Link>
            <Link
              to="#"
              className="p-2 bg-white/10 rounded-full hover:bg-Orange transition"
            >
              <FaWhatsapp />
            </Link>
            <Link
              to="#"
              className="p-2 bg-white/10 rounded-full hover:bg-Orange transition"
            >
              <FaYoutube />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
